/*
  Karte erst auf Klick. Vorher hing auf der Kontaktseite ein Google-Maps-
  `<iframe>` mit gesetztem `src` — schon das Öffnen der Seite schickte IP und
  Cookies an Google, ohne dass jemand gefragt worden wäre. Das Vorschaubild
  liegt im Theme und lädt nichts nach; die Adresse steht ohnehin daneben.
*/
(() => {
  class StoffeyaKarte extends HTMLElement {
    connectedCallback() {
      const knopf = this.querySelector('.karte__knopf');
      if (!knopf) return;
      knopf.addEventListener('click', () => this.laden(), { once: true });
    }

    laden() {
      const vorschau = this.querySelector('.karte__vorschau');
      const rahmen = document.createElement('iframe');
      rahmen.src = this.dataset.src;
      rahmen.className = 'karte__rahmen';
      rahmen.loading = 'lazy';
      rahmen.title = this.querySelector('.karte__bild').alt;
      rahmen.setAttribute('allowfullscreen', '');
      rahmen.referrerPolicy = 'no-referrer-when-downgrade';
      if (vorschau) vorschau.replaceWith(rahmen);
    }
  }
  if (!customElements.get('stoffeya-karte')) customElements.define('stoffeya-karte', StoffeyaKarte);
})();
